import { render, staticRenderFns } from "./HistoryContact.vue?vue&type=template&id=8f14e136"
import script from "./HistoryContact.vue?vue&type=script&lang=js"
export * from "./HistoryContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports